import { PropsWithChildren, createContext, useContext, useMemo } from 'react';
import { type AppModeSnapshot, resolveAppMode } from 'utils/appMode';

export type AppModeContextValue = AppModeSnapshot;

const AppModeContext = createContext<AppModeContextValue | null>(null);

export function AppModeProvider({ children }: PropsWithChildren) {
  const value = useMemo<AppModeContextValue>(() => resolveAppMode(), []);

  return <AppModeContext.Provider value={value}>{children}</AppModeContext.Provider>;
}

export function useAppMode() {
  const context = useContext(AppModeContext);

  if (!context) {
    throw new Error('useAppMode must be used within AppModeProvider');
  }

  return context;
}
